module.exports = __webpack_public_path__ + "media/images/emblems/Bonaduz_wappen-df0d48c0c4e7738b032624e083b2db5d.svg";